const reportWebVitals = onPerfEntry => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then((webVitals) => {
      const { getCLS, getFID, getFCP, getLCP, getTTFB } = webVitals;
      
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
      
      // INP (Interaction to Next Paint) - Core Web Vital
      // Check if onINP or getINP exists before calling
      if (webVitals.onINP && typeof webVitals.onINP === 'function') {
        webVitals.onINP(onPerfEntry);
      } else if (webVitals.getINP && typeof webVitals.getINP === 'function') {
        webVitals.getINP(onPerfEntry);
      }
      // If neither exists, INP will not be tracked (compatible with older versions)
    }).catch((error) => {
      // Silently fail if web-vitals can't be loaded
      console.warn('Failed to load web-vitals:', error);
    });
  }
};

// ส่ง Web Vitals ไป Google Analytics
const sendToAnalytics = (metric) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', metric.name, {
      event_category: 'Web Vitals',
      event_label: metric.id,
      value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
      non_interaction: true,
    });
  }
};

// Export สำหรับใช้ใน index.js
export default reportWebVitals;
export { sendToAnalytics };
